import React from 'react';
import { useEditorState } from '../store/editorStore.jsx';
import { getBlockDefinition } from '../core/registry.js';

/**
 * Inspector panel – renders the Inspector component for the currently
 * selected block.
 */
export function Inspector() {
  const { selectedId, history } = useEditorState();
  const doc = history.present;

  if (!selectedId) {
    return (
      <div className="editor-inspector p-3 text-muted small text-center">
        <div style={{ fontSize: '2rem' }}>🔍</div>
        <div className="mt-2">Select a block to edit its settings.</div>
      </div>
    );
  }

  const block = doc.blocks[selectedId];
  if (!block) return null;

  const def = getBlockDefinition(block.type);
  if (!def || !def.ui || !def.ui.Inspector) {
    return (
      <div className="editor-inspector p-3 text-muted small">
        No settings available for this block.
      </div>
    );
  }

  const InspectorComponent = def.ui.Inspector;
  return (
    <div className="editor-inspector">
      <div
        className="px-3 py-2 border-bottom d-flex align-items-center gap-2"
        style={{ background: '#f8f9fa' }}
      >
        <span style={{ fontSize: '1.1rem' }}>{def.ui.icon}</span>
        <span className="fw-semibold small">{def.ui.label}</span>
      </div>
      <InspectorComponent block={block} />
    </div>
  );
}
